function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopoverDialog, PopoverDialogContextualActionBar, PopoverDialogContextualActionBarCloseButton, PopoverDialogContextualActionBarSaveButton } from "sprout-ui-dom/dist/PopoverDialog";
import { useCallback, useRef, useState } from "react";
import { useAfterMountEffect } from "sprout-hooks";
import TextFieldPopoverDialogInner from "./TextFieldPopoverDialogInner";
const TextFieldPopoverDialog = (props)=>{
    const { text: textProp = "" , contextualTitle , onSubmit , placeholder , inputRef  } = props, rest = _objectWithoutProperties(props, [
        "text",
        "contextualTitle",
        "onSubmit",
        "placeholder",
        "inputRef"
    ]);
    const { open , onOpenChange  } = rest;
    const handleClose = useCallback(()=>{
        onOpenChange(false);
    }, [
        onOpenChange
    ]);
    const [text, setText] = useState(textProp);
    const textRef = useRef(text);
    const handleSubmit = useCallback(()=>{
        onSubmit(textRef.current);
    }, [
        onSubmit
    ]);
    const handleChange = useCallback((event)=>{
        const { value  } = event.target;
        setText(value);
        textRef.current = value;
    }, [
        setText,
        textRef
    ]);
    /**
   * Restore text to default value on exit
   */ useAfterMountEffect(()=>{
        if (!open) setText(textProp);
    }, [
        open,
        textProp
    ]);
    return /*#__PURE__*/ _jsxs(PopoverDialog, _objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ _jsx(PopoverDialogContextualActionBar, {
                contextualTitle: contextualTitle,
                leftAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarCloseButton, {
                    onClick: handleClose
                }),
                rightAction: /*#__PURE__*/ _jsx(PopoverDialogContextualActionBarSaveButton, {
                    onClick: handleSubmit
                })
            }),
            /*#__PURE__*/ _jsx(TextFieldPopoverDialogInner, {
                text: text,
                onChange: handleChange,
                onSubmit: handleSubmit,
                onRequestClose: handleClose,
                placeholder: placeholder,
                inputRef: inputRef
            })
        ]
    }));
};
export default TextFieldPopoverDialog;
